import Billing from './Billing';
import BrandProfile from './BrandProfile';
import Preferences from './Preferences';
import Profile from './Profile';
import Statements from './Statements';
import PaypalConnection from './PaypalConnection';
import PartnerSubscription from './PartnerSubscription'
export {
  Billing, BrandProfile, Preferences, Profile, Statements, PaypalConnection, PartnerSubscription
}



// WEBPACK FOOTER //
// ./src/components/settings/index.js